/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Tab_Setclip1Inputs */

const en_settings_tab_setclip1 = /** @type {(inputs: Settings_Tab_Setclip1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Set Clip`)
};

const de_settings_tab_setclip1 = /** @type {(inputs: Settings_Tab_Setclip1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Set Clip`)
};

/**
* | output |
* | --- |
* | "Set Clip" |
*
* @param {Settings_Tab_Setclip1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const settings_tab_setclip1 = /** @type {((inputs?: Settings_Tab_Setclip1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Tab_Setclip1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_tab_setclip1(inputs)
	return de_settings_tab_setclip1(inputs)
});
export { settings_tab_setclip1 as "settings_tab_setClip" }